import type { OrdersQueryVariables } from 'src/api/order_repository';

/**
 * Central React Query keys for order-related caches.
 * Prefer these over ad-hoc string arrays so invalidate/set stay consistent.
 */
export const orderKeys = {
  all: ['orders'] as const,
  lists: () => [...orderKeys.all] as const,
  list: (params: OrdersQueryVariables) =>
    [...orderKeys.lists(), params] as const,
  details: () => ['order'] as const,
  detail: (orderId: string) => [...orderKeys.details(), orderId] as const,
  forReviseReport: (orderId: string) =>
    ['orderForReviseReport', orderId] as const,
};

export const orderingProviderKeys = {
  // Mutable string[] so it can be passed to VirtualizedAutocomplete queryKey props.
  all: ['orderingProviders'] as string[],
};
